import {Component} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudMandantService} from '../../../../shared/services/crud-mandant.service';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService, IAlert} from '@shared/services/alert.service';
import {GlobalsService} from '@shared/services/globals.service';
import {CrudLanguagesService} from '@shared/services/crud-languages.service';

export interface TabType {
  label: string;
  fields: FormlyFieldConfig[];
}

export interface AttributeDetail {
  id: number;
  attribute: string;
  type: string;
}

export interface AttributeGroup {
  id: number;
  label: string;
  details: AttributeDetail[];
}

@Component({
  selector: 'app-mandant-edit',
  templateUrl: './mandant-edit.component.html',
  styleUrls: ['./mandant-edit.component.scss']
})
export class MandantEditComponent extends AbstractCrudEditComponent {

  entityForm: UntypedFormGroup;
  options: FormlyFormOptions = {};

  tabs: TabType[];


  // mandant payload
  // x = {
  //   'id': 1,
  //   'name': 'DEVELOP',
  //   'active': true,
  //   'description': '',
  //   'subClients': '',
  //   'piwikSiteId': '',
  //   'piwikUrl': 'piwik.media4.ch',
  //   'calitho.admin_email_recipients': '',
  //   'ib.cavok.rootpath': '',
  //   'ib.cavok.wsdl': '',
  //   'ib.encrypted.password': '',
  //   'mailer.register_email_recipients': '',
  //   'debug': '',
  //   'debug_addresses': '',
  //   'from': 'portaldevelop@calitho.ch',
  //   'myProfileCanges': '',
  //   'smtp_server': 'mail.media4.ch',
  //   'additionalCSS': '.line .attrib input {\n    width:200px;\n}',
  //   'assets_uri_root': 'https://<>',
  //   'backgroundImage': 'URLPATHhtml/img/style3/bg-body.jpg',
  //   'hideMyProfile': '',
  //   'maintenance_mode': false,
  //   'maintenance_mode_msg': '',
  //   'mandant_background': '/images/develop/background.jpg',
  //   'mandant_body_bgimg': '/0/blank.jpg',
  //   'mandant_header_bgcolor': 'grey',
  //   'mandant_header_height': '100px',
  //   'mandant_header_logo_logged': '/0/blank.jpg',
  //   'mandant_header_txtcolor': 'text-white',
  //   'mandant_logo_singin': '/0/blank.jpg',
  //   'mandant_theme': '/css/theme-develop.css',
  //   'validBrowserHelp': '',
  //   'Contact_info': '',
  //   'Edit': '',
  //   'Last_login': '',
  //   'lngPref': '',
  //   'loginInfo': '',
  //   'Position': '',
  //   'addressLine1': '',
  //   'addressLine2': '',
  //   'city': '',
  //   'companyName': '',
  //   'confirm_pwd': '',
  //   'country': '',
  //   'email': '',
  //   'fax': '',
  //   'first_name': '',
  //   'last_login': '',
  //   'last_name': '',
  //   'lngLanguage_fkID': '',
  //   'middle_name': '',
  //   'mobile': '',
  //   'password': '',
  //   'phone': '',
  //   'position': '',
  //   'state': '',
  //   'username': '',
  //   'usrTitle_fkID': '',
  //   'website': '',
  //   'zipcode': '',
  //   'languages': [{'id': 1, 'value': 1, 'label': 'EN', 'iso2': 'en'}, {'id': 2, 'value': 2, 'label': 'DE', 'iso2': 'de'}, {
  //     'id': 3,
  //     'value': 3,
  //     'label': 'FR',
  //     'iso2': 'fr'
  //   }],
  //   'lngSelectValues': [1, 2, 3],
  //   'attributegroups': [
  //     {
  //       'id': 10,
  //       'label': 'global',
  //       'details': [{'id': 12, 'attribute': 'piwikSiteId', 'type': 'text', 'placeholder': 'Piwik Seiten ID, leer deaktiviert Piwik'}, {
  //         'id': 13,
  //         'attribute': 'piwikUrl',
  //         'type': 'text',
  //         'placeholder': 'URL to Piwik ohne http://'
  //       }
  //       ]
  //     }, {
  //       'id': 11,
  //       'label': 'imagebank-specific',
  //       'details': [{
  //         'id': 19,
  //         'attribute': 'calitho.admin_email_recipients',
  //         'type': 'text',
  //         'placeholder': 'List here calitho admin e-mails separated by ";"'
  //       }, {
  //         'id': 22,
  //         'attribute': 'ib.cavok.rootpath',
  //         'type': 'text',
  //         'placeholder': 'The url absolute root of soap assets resources (end with trailing slash) http://192.168.111.65/soap/getfile?sid=xxxx'
  //       }, {'id': 21, 'attribute': 'ib.cavok.wsdl', 'type': 'text', 'placeholder': 'Set here the url of the cavok wsdl'}, {
  //         'id': 18,
  //         'attribute': 'ib.encrypted.password',
  //         'type': 'text',
  //         'placeholder': '0: plaintext, 1: md5, 2: bcrypt'
  //       }, {'id': 17, 'attribute': 'mailer.register_email_recipients', 'type': 'text', 'placeholder': 'List here e-mails separated by ";"'}]
  //     }, {
  //       'id': 6,
  //       'label': 'mailing',
  //       'details': [{'id': 4, 'attribute': 'debug', 'type': 'text', 'placeholder': ''}, {
  //         'id': 5,
  //         'attribute': 'debug_addresses',
  //         'type': 'text',
  //         'placeholder': ''
  //       }, {'id': 7, 'attribute': 'from', 'type': 'text', 'placeholder': ''}, {
  //         'id': 10,
  //         'attribute': 'myProfileCanges',
  //         'type': 'text',
  //         'placeholder': 'Empfänger der myProfile Änderungs email, leer=deaktiviert'
  //       }, {'id': 6, 'attribute': 'smtp_server', 'type': 'text', 'placeholder': ''}]
  //     }, {
  //       'id': 8,
  //       'label': 'styles',
  //       'details': [{
  //         'id': 8,
  //         'attribute': 'additionalCSS',
  //         'type': 'textarea',
  //         'placeholder': 'Layout Optionen pro Mandant.<a target="_blank" href="lib/css/sample_mandant_additional.css">Klick for a Template</a>'
  //       }, {'id': 33, 'attribute': 'assets_uri_root', 'type': 'text', 'placeholder': null}, {
  //         'id': 11,
  //         'attribute': 'backgroundImage',
  //         'type': 'text',
  //         'placeholder': 'backgroundImage'
  //       }, {'id': 14, 'attribute': 'hideMyProfile', 'type': 'text', 'placeholder': '1 um das MyProfileMenu auszublenden'}, {
  //         'id': 36,
  //         'attribute': 'maintenance_mode',
  //         'type': 'checkbox',
  //         'placeholder': null
  //       }, {'id': 37, 'attribute': 'maintenance_mode_msg', 'type': 'textarea', 'placeholder': null}, {
  //         'id': 16,
  //         'attribute': 'mandant_background',
  //         'type': 'text',
  //         'placeholder': null
  //       }, {'id': 24, 'attribute': 'mandant_body_bgimg', 'type': 'text', 'placeholder': null}, {
  //         'id': 28,
  //         'attribute': 'mandant_header_bgcolor',
  //         'type': 'text',
  //         'placeholder': null
  //       }, {'id': 27, 'attribute': 'mandant_header_height', 'type': 'text', 'placeholder': null}, {
  //         'id': 26,
  //         'attribute': 'mandant_header_logo_logged',
  //         'type': 'text',
  //         'placeholder': null
  //       }, {'id': 29, 'attribute': 'mandant_header_txtcolor', 'type': 'text', 'placeholder': null}, {
  //         'id': 25,
  //         'attribute': 'mandant_logo_singin',
  //         'type': 'text',
  //         'placeholder': null
  //       }, {'id': 15, 'attribute': 'mandant_theme', 'type': 'text', 'placeholder': null}]
  //     }, {
  //       'id': 9,
  //       'label': 'system',
  //       'details': [{
  //         'id': 9,
  //         'attribute': 'validBrowserHelp',
  //         'type': 'drawFieldHelpSelect',
  //         'placeholder': 'Wenn definiert, wird die Browser Validierung eingeschaltet'
  //       }]
  //     }]
  // };

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private httpcrud: CrudMandantService,
    private httplanguagecrud: CrudLanguagesService,
    protected apifactory: ApiFactoryService,
    private globalservice: GlobalsService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, httpcrud, alertService);

    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'name',
                type: 'input',
                defaultValue: '',
                props: {label: 'Name', required: true}
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'description',
                type: 'input',
                defaultValue: '',
                props: {label: 'Description'}
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'lngSelectValues',
                type: 'ng-select',
                props: {
                  label: 'Languages',
                  multiple: true,
                  required: true,
                  options: []
                },
                hooks: {
                  onInit: this.initLanguages
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'active',
                type: 'checkbox',
                defaultValue: false,
                props: {label: 'Active'}
              }
            ]
          },
        ]
      }
    ];
    this.tabs = [];

    this.createSectionTitle = 'Create mandant';
    this.updatePrefixTitle = 'Edit mandant: ';
    this.entityrooturl = '/admin/mandant';
    this.labelFieldName = 'name';
  }

  private getLanguageOptions() {

  } // getLanguageOptions

  getAndConfigureEmptyDynamicFields() {
    this.httpcrud.getMandantFormFields().subscribe((data) => {
      const fields = data.results;

      if (fields.hasOwnProperty('attributegroups')) {
        this.setDynamicAttributeGroupsFields(fields.attributegroups);
      } // if

      // Update language field select option
      if (fields.hasOwnProperty('languages')) {
        this.updateStaticSelectFieldsOptions({
          lngSelectValues: fields.languages
        });
      } // if

      this.setReady();
    });
  } // getAndConfigureEmptyDynamicFields

  getModelAndConfigureDynamicFields() {
    this.httpcrud.getEntity(this.entityid).subscribe((data) => {

      const fields = data.results;

      if (fields.hasOwnProperty('name')) {
        this.sectionTitle = 'Edit mandant: ' + fields.name;
      } // if

      // Treat fields
      if (fields.hasOwnProperty('attributegroups')) {
        this.setDynamicAttributeGroupsFields(fields.attributegroups);
      } // if

      // Update language field select option
      if (fields.hasOwnProperty('languages')) {
        this.updateStaticSelectFieldsOptions({
          lngSelectValues: fields.languages
        });
      } // if

      // Init model
      this.model = this.globalservice.transformFlatJsonKeyFromPointToSeparator(fields);

      this.setReady();
    });
  } // getModelAndConfigureDynamicFields

  setDynamicAttributeGroupsFields(attributeGroupFields: AttributeGroup[]) {

    const tabConfig: FormlyFieldConfig = {
      type: 'tabs',
      fieldGroup: []
    };

    for (const attributegroup of attributeGroupFields) {

      // Prepare fields in a tab
      const attributedetails = attributegroup.details;
      const tmp = [];

      for (const attributedetail of attributedetails) {
        const selectedType = this.globalservice.mapPortalToFormlyFieldType(attributedetail.type);

        if (selectedType) {

          const props: { [propName: string]: any; } = {};
          props.label = attributedetail.attribute;
          if (selectedType.hasOwnProperty('addedTemplateOptions')) {
            const addedTemplateOptions = selectedType.addedTemplateOptions;

            if (addedTemplateOptions.hasOwnProperty('type')) {
              props.type = addedTemplateOptions.type;
            } // if

            if (addedTemplateOptions.hasOwnProperty('required')) {
              props.required = addedTemplateOptions.required;
            } // if

          } // if

          const replacedKey = this.globalservice.stringReplace(attributedetail.attribute, '\\.', '|');
          tmp.push({
            key: replacedKey,
            type: selectedType.type,
            wrappers: ['form-field-horizontal'],
            defaultValue: selectedType.defaultValue,
            props,
          });
        } // if
      } // for

      tabConfig.fieldGroup.push({
        props: { label: attributegroup.label },
        fieldGroup: tmp
      });

    } // for

    this.fields = [...this.fields, tabConfig];

  } // configureDynamicAttributeGroups

  onSubmitHandler(): any {
    return () => {
      this.form.markAllAsTouched();
      if (this.form.valid) {
        this.isSubmitting = true;

        // Transform flat json keys with | to .
        const transformedModel = this.globalservice.transformFlatJsonKeyFromSeparatorToPoint(this.model);

        if (this.model.id) {
          // edit submit
          this.httpCrud.updateEntity(this.model.id, transformedModel).subscribe(() => {
            this.isSubmitting = false;
            this.alertService.addAlert({
              type: 'success',
              title: 'Mandant updated',
              message: `The mandant has been updated successfully`,
            } as IAlert);
          });
        } else {
          // create submit
          this.httpCrud.createEntity(transformedModel).subscribe(() => {
            this.isSubmitting = false;
            this.router.navigate([this.entityrooturl]).then(() => {
              this.alertService.addAlert({
                type: 'success',
                title: 'New mandant created',
                message: `New mandant has been created successfully`,
              } as IAlert);
            });
          });
        }
      } else {
        // form not valid
        this.alertService.addAlert({
          type: 'danger',
          title: 'Error',
          message: `Incorrect inputs. Please review the form data.`,
        } as IAlert);
      }
    };
  }

  updateStaticSelectFieldsOptions(mapfield: {}) {
    for (const item of this.fields) {
      const itemkey: any = item.key;
      if (mapfield.hasOwnProperty(itemkey)) {
        item.props.options = mapfield[itemkey];
      } // if
    } // for
  } //

  initLanguages = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    this.httplanguagecrud.getEntities().subscribe((data) => {
      const languages = data.results;
      typedField.props.options = [...languages];
    });
  }
}

